import { Component, computed, inject } from '@angular/core';
import { UiButtonComponent, UiDividerComponent, UiNumberComponent } from '@design-system';
import { OrderFormFacade } from '../../data-access/order-form.facade';
import {
	calculateBreakevenPrice,
	calculateCommissionValue,
	calculateTradeValue
} from '../../tools/order-form-summary.tools';
import { OrderFormProducerService } from '../../../../events/order-form/order-form-producer.service';

export interface OrderFormSummaryData {
	/** دارایی فعلی */
	currentAsset: number;
	/** قدرت خرید */
	buyingPower: number;
	/** قیمت سربه‌سر — null when not applicable (sell without assets) */
	breakEvenPrice: number | null;
	/** کارمزد معامله */
	dealExpense: number;
	/** ارزش معامله / جمع کل */
	totalExpense: number;
}

@Component({
	selector: 'app-order-form-summary',
	templateUrl: './order-form-summary.component.html',
	imports: [UiNumberComponent, UiDividerComponent, UiButtonComponent],
	host: {
		class: 'flex w-full flex-col gap-3'
	}
})
export class OrderFormSummaryComponent {
	private readonly orderFormFacade = inject(OrderFormFacade);
	private readonly orderFormProducer = inject(OrderFormProducerService);

	onCurrentAssetClick(): void {
		const quantity = this.summary().currentAsset;
		this.orderFormProducer.updateOrderForm({ quantity });
	}

	readonly summary = computed<OrderFormSummaryData>(() => {
		const { side, price, quantity } = this.orderFormFacade.orderFormModel();
		const buyRate = this.orderFormFacade.buyCommissionRate();
		const sellRate = this.orderFormFacade.sellCommissionRate();
		const enteredPrice = price ?? 0;
		const enteredQuantity = quantity ?? 0;
		const currentAsset = this.orderFormFacade.currentAsset();

		return {
			currentAsset,
			buyingPower: this.orderFormFacade.buyingPower(),
			breakEvenPrice: calculateBreakevenPrice(
				side,
				enteredPrice,
				this.orderFormFacade.averageBuyPrice(),
				currentAsset,
				buyRate,
				sellRate
			),
			dealExpense: calculateCommissionValue(side, enteredPrice, enteredQuantity, buyRate, sellRate),
			totalExpense: calculateTradeValue(side, enteredPrice, enteredQuantity, buyRate, sellRate)
		};
	});
}
